var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"80c66339463dddd14383573f0be56e7d075159c2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["archivizer-com@archivizer"]={id:"80c66339463dddd14383573f0be56e7d075159c2"};
      